<template>
    <section>
        <div class="event-box">
            <div v-if="edit">
                <div class="data">
                    <input v-model="event.liters" type="text" class="control-inline form-control"> {{$t('message.liters')}}
                </div>
                <div class="actions">
                    <b-btn @click="save" type="success">{{$t('message.save')}}</b-btn>
                    <b-btn @click="remove"><i class="fa fa-trash"></i></b-btn>
                </div>
            </div>
            <div v-else>
                <div class="data">
                    {{event.liters}} {{$t('message.liters')}}
                </div>
                <div class="actions">
                    <b-btn @click="edit=true"><i class="fa fa-pencil"></i></b-btn>
                    <b-btn @click="remove"><i class="fa fa-trash"></i></b-btn>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Base from './Base'

    export default {
        name: 'Flow',
        extends: Base
    }
</script>

<style scoped>
    @import 'base.css';
</style>
